import { Icon } from '@acme/assets';
import { TextInput } from 'flowbite-react';
import type { PropsWithChildren } from 'react';

export interface SidebarProps extends PropsWithChildren {
  searchValue: string;
  onSearchChange: (value: string) => void;
}

export const Sidebar = (props: SidebarProps) => {
  return (
    <div className="flex w-80 shrink-0 flex-col border-r border-gray-200 bg-white">
      <div className="flex h-16 items-center justify-center gap-2 border-b border-gray-200 px-3">
        <Icon name="message-dots-outline" size={16} />
        <p className="text-base font-medium text-gray-900">Чаты</p>
      </div>

      <div className="px-4 pt-4">
        <TextInput
          value={props.searchValue}
          onChange={(e) => props.onSearchChange(e.target.value)}
          placeholder="Напишите имя или компанию"
          icon={() => <Icon name="search-outline" size={16} />}
        />
      </div>

      <div className="flex-1 overflow-y-auto pt-4">{props.children}</div>
    </div>
  );
};
